import {keepPreviousData, useQuery} from "@tanstack/react-query";

import type {ParamsOptions} from "@/src/modules/core/types";

import {companyOnGuardService} from "../services";

type UseCompanyOnGuardAssigneesParams = ParamsOptions & {
  companyId: number | undefined;
  enabled?: boolean;
  refetchInterval?: number | false;
  refetchOnWindowFocus?: boolean;
};

export function useCompanyOnGuardAssignees({
  companyId,
  enabled = true,
  refetchInterval,
  refetchOnWindowFocus,
  ...paramsOptions
}: UseCompanyOnGuardAssigneesParams) {
  const queryOptions: ParamsOptions = {
    sort: "display_order",
    ...paramsOptions,
  };

  const query = useQuery({
    queryKey: ["company-on-guard-users", companyId, queryOptions],
    queryFn: () => companyOnGuardService.getAssignees(companyId!, queryOptions),
    enabled: enabled && companyId != null,
    placeholderData: keepPreviousData,
    refetchInterval,
    refetchOnWindowFocus,
  });

  return {
    assignees: query.data?.data ?? [],
    total: query.data?.meta.total ?? 0,
    isPending: query.isPending,
    isFetching: query.isFetching,
    error: query.error,
    refetch: query.refetch,
  };
}
